import React from 'react'
import Carousel from 'nuka-carousel'
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left'
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right'
import OutreachCard from '../Outreach/OutreachCard'

import eventsConfig from '../../configs/events-config'

const OutreachBody = ({ className, browser }) => {
  const browserLessThanSmall = browser.lessThan.small
  const browserLessThanMedium = browser.lessThan.medium
  const browserLessThanLarge = browser.lessThan.large
  let slidesToShow

  if (browserLessThanLarge) {
    if (browserLessThanMedium) {
      slidesToShow = 1.2
    } else {
      slidesToShow = 3.2
    }
  } else {
    slidesToShow = 4
  }

  const Decorators = [{
    component: React.createClass({
      render() {
        return (
          <div
            onClick={this.props.previousSlide}>
            <ChevronLeft style={{color: 'white', height: '50px', width: '50px'}} />
          </div>
        )
      }
    }),
    position: 'CenterLeft',
    style: {
      padding: 20
    }
  },{
    component: React.createClass({
      render() {
        return (
          <div
            onClick={this.props.nextSlide}>
            <ChevronRight style={{color: 'white', height: '50px', width: '50px'}} />
          </div>
        )
      }
    }),
    position: 'CenterRight',
    style: {
      padding: 20
    }
  }];

  const settings = {
    autoplay: browserLessThanSmall ? true : false,
    cellSpacing: 30,
    decorators: Decorators,
    slidesToShow: slidesToShow,
    slideWidth: '270px',
    width: '100%',
    wrapAround: false
  }

  const cards = Object.keys(eventsConfig).map((key, index) => {
    const event = eventsConfig[key]

    return (
      <OutreachCard event={event} key={index} />
    );
  });

  return (
    <div className={className}>
      <Carousel {...settings}>{cards}</Carousel>
    </div>
  );
}

export default OutreachBody



// WEBPACK FOOTER //
// ./src/components/Home/OutreachBody.js